module.exports = __webpack_public_path__ + "img/logo.ac202362.png";